import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import React from 'react';

function AffiliteReview({ reviewSection, name }: any) {
  return (
    <div
      className={ivclass(
        'iv-container iv-mx-auto iv-max-w-3xl',
        'iv-flex iv-flex-col iv-justify-center',
        'iv-pt-200 xl:iv-pt-150 md:iv-pt-100 sm:iv-pt-50',
        'iv-px-20',
      )}
    >
      <div
        className={ivclass(
          'iv-mx-auto iv-rounded-30',
          'iv-pb-40 md:iv-pb-30 sm:iv-pb-20',
        )}
      >
        <ImageComponent
          className={ivclass('iv-w-[140px]', 'iv-rounded-full')}
          elementype="native"
          src={reviewSection.img.webp}
          alt={reviewSection.img.alt}
        />
      </div>
      <p
        className={ivclass(
          'iv-text-body-5xl md:iv-text-body-3xl sm:iv-text-body-2xl',
          'iv-pb-20',
        )}
      >
        {reviewSection.para}
      </p>
      <div className={ivclass('iv-text-body-5xl iv-text-center')}>- {name}</div>
    </div>
  );
}

export default AffiliteReview;
